module.exports = __webpack_public_path__ + "0d51565173f104011520cb6258c5e7c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/backgrounds/personal-sponsored-challenges.jpg
// module id = 1861
// module chunks = 1